import Tabs from '../util/tabs';

class SuccessStories {
  constructor(el) {
    this.el = el;
    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    new Tabs({
      el: this.el,
    });
  }
}

export default SuccessStories;
